// extracted by mini-css-extract-plugin
export var attachmentContainer = "_if-0";
export var fileList = "_if-2";
export var removeFileButton = "_if-1";